import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Paper, Grid, ButtonGroup, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@mdi/react';
import {
    mdiFormatListBulletedType, mdiRoutesClock, mdiMotion,
    mdiBusStop, mdiAlertBox,
} from '@mdi/js';

import {
    timeLineViewSelector,
    bottomViewSelector
} from '../../features/datacenter/historySlice';
import { setTimeLineView, setbottomView } from '../../features/datacenter/historySlice';

import TimeLineDriveItem from './TimeLineDriveItem';
import TimeLineStopItem from './TimeLineStopItem';
import TimeLineEventItem from './TimeLineEventItem';
import TimeLineSummaryItem from './TimeLineSummaryItem';
import TrackListItem from './TrackListItem';

const TrackTimeLineView = () => {
    const dispatch = useDispatch();
    const timeLineView = useSelector(timeLineViewSelector);
    const trackData = useSelector(state => state.history.trackData[timeLineView]);
    const viewType = useSelector(bottomViewSelector);
    //const { trackData } = trackData;
    



    const changeTimelineDisplayItem = (type) => {
        dispatch(setTimeLineView(timeLineView));
        dispatch(setbottomView(type));
    }


    const timelineBuilder = () => {
        let timeline = [];
        trackData.reportRecords.forEach((t, i) => {
            switch (t.type) {
                case 'drive':
                    if (viewType === 'timeline' || viewType === 'drives') {
                        timeline.push(
                            <Grid item sm={12} key={i}><TimeLineDriveItem data={t} track={trackData.track} /></Grid>
                        )
                    }

                    break;
                case 'stop':
                    if (viewType === 'timeline' || viewType === 'stops') {
                        timeline.push(
                            <Grid item sm={12} key={i}><TimeLineStopItem data={t} track={trackData.track} /></Grid>
                        )
                    }
                    break;
                case 'event':
                    if (viewType === 'timeline' || viewType === 'events') {
                        timeline.push(
                            <Grid item sm={12} key={i}><TimeLineEventItem data={t} track={trackData.track} /></Grid>
                        )
                    }
                    break;
                default:
                    break;
            }
        })

        return timeline;
    }

    const eventTimeLineBuilder = () => {
        return trackData.events.map((e, i) => <Grid item sm={12} key={i}><TimeLineEventItem data={e} track={trackData.track} /></Grid>)
    }

    if (timeLineView && trackData) {
        return (
            <div>
                <Paper elevation={3}>
                    <div style={{ margin: '5px' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item sm={12}>
                                <TrackListItem key={timeLineView} reportID={timeLineView} />
                            </Grid>
                            <Grid item sm={12} container>
                                <Grid item sm={12}>
                                    <ButtonGroup>
                                        <Tooltip title="Show Summary">
                                            <IconButton onClick={() => changeTimelineDisplayItem('summary')} size="large">
                                                <Icon
                                                    path={mdiFormatListBulletedType}
                                                    title="Show Summary"
                                                    size={0.8}
                                                    color="DodgerBlue"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Show Timeline">
                                            <IconButton onClick={() => changeTimelineDisplayItem('timeline')} size="large">
                                                <Icon
                                                    path={mdiRoutesClock}
                                                    title="Show Timeline"
                                                    size={0.8}
                                                    color="DarkSlateGray"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Show Drives">
                                            <IconButton onClick={() => changeTimelineDisplayItem('drives')} size="large">
                                                <Icon
                                                    path={mdiMotion}
                                                    title="Show Drives"
                                                    size={0.8}
                                                    color="ForestGreen"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Show Stops">
                                            <IconButton onClick={() => changeTimelineDisplayItem('stops')} size="large">
                                                <Icon
                                                    path={mdiBusStop}
                                                    title="Show Stops"
                                                    size={0.8}
                                                    color="GoldenRod"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Show Events">
                                            <IconButton onClick={() => changeTimelineDisplayItem('events')} size="large">
                                                <Icon
                                                    path={mdiAlertBox}
                                                    title="Show Events"
                                                    size={0.8}
                                                    color="Tomato"
                                                />
                                            </IconButton>
                                        </Tooltip>

                                    </ButtonGroup>

                                </Grid>
                                <Grid item sm={12}>
                                    {
                                        viewType === 'summary' ?
                                            <Grid item sm={12}>
                                                <TimeLineSummaryItem trackData={trackData} />
                                            </Grid>
                                            :
                                            viewType === 'events' ?
                                                eventTimeLineBuilder()
                                                :
                                                timelineBuilder()
                                    }
                                </Grid>


                            </Grid>

                        </Grid>
                    </div>


                </Paper>
            </div>
        );
    } else {
        return null;
    }


}

export default TrackTimeLineView;

/*<Tooltip title="Close Timeline">
    <IconButton onClick={closeTimeLine}>
        <Icon
            path={mdiCloseOctagon}
            title="Close Timeline"
            size={0.8}
            color="Red"
        />
    </IconButton>
</Tooltip>*/